import React, { useState, useEffect } from 'react';
import { Link, useNavigate } from 'react-router-dom';
import axios from 'axios';
import SideBar from '../usercomponents/SideBar';
import TopNavBar from '../usercomponents/TopNavBar';
import Footer from '../usercomponents/Footer';
const apiUrl = process.env.REACT_APP_API_URL;
function StudentProfile() {
  const [profile, setProfile] = useState({
    firstName: '', lastName: '', username: '', email: '', aadharNo: '', mobile: '',
    address: '', postcode: '', mainTelephone: '', degree: '', engineering: '',
    currentStatus: '', preferableCourse: '', batch: '', studentid: ''
  });
  const [newPassword, setNewPassword] = useState('');
  const [confirmPassword, setConfirmPassword] = useState('');
  const [message, setMessage] = useState('');
  const [messageType, setMessageType] = useState('');
  const [loading, setLoading] = useState(false);
  const navigate = useNavigate();
  useEffect(() => {
    fetchProfile();
  }, []);
  const fetchProfile = async () => {
    setLoading(true);
    setMessage('');
    setMessageType('');
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('studentSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to view your profile.');
        setMessageType('error');
        setLoading(false);
        return;
      }
      const response = await axios.get(`${apiUrl}/api/student/profile`, {
        headers: { Authorization: `Bearer ${sessionData.token}` },
        params: { ts: Date.now() }
      });
      if (response.data.success) {
        setProfile(response.data.profile);
      } else {
        setMessage(response.data.message || 'Failed to fetch profile.');
        setMessageType('error');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error fetching profile.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };
  const handleInputChange = (e) => {
    const { id, value } = e.target;
    setProfile((prev) => ({ ...prev, [id]: value }));
  };
  const handleSubmit = async (e) => {
    e.preventDefault();
    setLoading(true);
    setMessage('');
    setMessageType('');
    if (newPassword && newPassword !== confirmPassword) {
      setMessage('Passwords do not match.');
      setMessageType('error');
      setLoading(false);
      return;
    }
    try {
      const sessionData = JSON.parse(sessionStorage.getItem('studentSession'));
      if (!sessionData || !sessionData.token) {
        setMessage('You must be logged in to update your profile.');
        setMessageType('error');
        setLoading(false);
        return;
      }
      const updateData = {
        email: profile.email,
      };
      if (newPassword) {
        updateData.password = newPassword;
      }
      const response = await axios.put(`${apiUrl}/api/student/profile`, updateData, {
        headers: { Authorization: `Bearer ${sessionData.token}` }
      });
      if (response.data.success) {
        setMessage('Profile updated successfully!');
        setMessageType('success');
        setNewPassword('');
        setConfirmPassword('');
        sessionData.email = updateData.email;
        sessionStorage.setItem('studentSession', JSON.stringify(sessionData));
      } else {
        setMessage(response.data.message || 'Failed to update profile.');
        setMessageType('error');
      }
    } catch (err) {
      setMessage(err.response?.data?.message || 'Error updating profile.');
      setMessageType('error');
    } finally {
      setLoading(false);
    }
  };
  return (
    <>
      <SideBar />
      <div className="dashboard-main-wrapper">
        <TopNavBar />
        <div className="dashboard-body">
          <div className="breadcrumb-with-buttons mb-24 flex-between flex-wrap gap-8">
            <div className="breadcrumb mb-24">
              <ul className="flex-align gap-4">
                <li>
                  <Link to="/student-dashboard" className="text-gray-200 fw-normal text-15 hover-text-main-600">
                    Home
                  </Link>
                </li>
                <li>
                  <span className="text-gray-500 fw-normal d-flex">
                    <i className="ph ph-caret-right" />
                  </span>
                </li>
                <li>
                  <span className="text-main-600 fw-normal text-15">Profile</span>
                </li>
              </ul>
            </div>
          </div>
          <div className="card overflow-hidden shadow-sm border-0">
            <div className="card-body p-24">
              <h4 className="mb-16 text-main-600 fw-bold">Student Profile</h4>
              {message && (
                <div className={`alert alert-${messageType === 'success' ? 'success' : 'danger'} mb-16`} role="alert">
                  {message}
                </div>
              )}
              {loading ? (
                <div className="text-center my-5">
                  <div className="spinner-border text-primary" role="status">
                    <span className="visually-hidden">Loading...</span>
                  </div>
                </div>
              ) : (
                <form onSubmit={handleSubmit}>
                  <div className="row g-3">
                    <div className="col-md-6">
                      <label htmlFor="studentid" className="form-label fw-medium">Student ID</label>
                      <input
                        type="text"
                        className="form-control"
                        id="studentid"
                        value={profile.studentid}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="firstName" className="form-label fw-medium">First Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="firstName"
                        value={profile.firstName}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="lastName" className="form-label fw-medium">Last Name</label>
                      <input
                        type="text"
                        className="form-control"
                        id="lastName"
                        value={profile.lastName}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="username" className="form-label fw-medium">Username</label>
                      <input
                        type="text"
                        className="form-control"
                        id="username"
                        value={profile.username}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="email" className="form-label fw-medium">Email</label>
                      <input
                        type="email"
                        className="form-control"
                        id="email"
                        value={profile.email}
                        onChange={handleInputChange}
                        required
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="aadharNo" className="form-label fw-medium">Aadhar No./Emirates ID</label>
                      <input
                        type="text"
                        className="form-control"
                        id="aadharNo"
                        value={profile.aadharNo}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="mobile" className="form-label fw-medium">Mobile</label>
                      <input
                        type="text"
                        className="form-control"
                        id="mobile"
                        value={profile.mobile}
                        disabled
                      />
                    </div>
                    <div className="col-12">
                      <label htmlFor="address" className="form-label fw-medium">Address</label>
                      <input
                        type="text"
                        className="form-control"
                        id="address"
                        value={profile.address}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="postcode" className="form-label fw-medium">Postcode</label>
                      <input
                        type="text"
                        className="form-control"
                        id="postcode"
                        value={profile.postcode}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="mainTelephone" className="form-label fw-medium">Main Telephone</label>
                      <input
                        type="text"
                        className="form-control"
                        id="mainTelephone"
                        value={profile.mainTelephone}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="degree" className="form-label fw-medium">Degree</label>
                      <input
                        type="text"
                        className="form-control"
                        id="degree"
                        value={profile.degree}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="engineering" className="form-label fw-medium">Engineering</label>
                      <input
                        type="text"
                        className="form-control"
                        id="engineering"
                        value={profile.engineering}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="currentStatus" className="form-label fw-medium">Current Status</label>
                      <input
                        type="text"
                        className="form-control"
                        id="currentStatus"
                        value={profile.currentStatus}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="preferableCourse" className="form-label fw-medium">Preferred Course</label>
                      <input
                        type="text"
                        className="form-control"
                        id="preferableCourse"
                        value={profile.preferableCourse}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="batch" className="form-label fw-medium">Batch</label>
                      <input
                        type="text"
                        className="form-control"
                        id="batch"
                        value={profile.batch}
                        disabled
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="newPassword" className="form-label fw-medium">New Password (leave blank to keep current)</label>
                      <input
                        type="password"
                        className="form-control"
                        id="newPassword"
                        value={newPassword}
                        onChange={(e) => setNewPassword(e.target.value)}
                      />
                    </div>
                    <div className="col-md-6">
                      <label htmlFor="confirmPassword" className="form-label fw-medium">Confirm New Password</label>
                      <input
                        type="password"
                        className="form-control"
                        id="confirmPassword"
                        value={confirmPassword}
                        onChange={(e) => setConfirmPassword(e.target.value)}
                      />
                    </div>
                  </div>
                  <button type="submit" className="btn btn-primary mt-4" disabled={loading}>
                    {loading ? 'Updating...' : 'Update Profile'}
                  </button>
                </form>
              )}
            </div>
          </div>
        </div>
        <Footer />
      </div>
    </>
  );
}
export default StudentProfile;